// angular
//  .module("HeroPRO")
//  .controller("PipelineFilterModalController", pipelineFilterModalController);

import _ from 'lodash';

import './pipelineFilterModal.scss';

/* @ngInject */
export default function pipelineFilterModalController($scope, PipelineFilterFactory, PipelineFactory, PipelineMappings, UserData, $state, $filter) {
    const vm = this;

    vm.selectedStage = {};
    vm.lastStage = {};
    vm.selectedColumn = {};
    vm.selectedOperator = {};

    vm.filterValue = '';
    vm.filterFirstName = '';

    vm.opened = false;

    vm.filterTermPlaceholderText = 'Enter Term';
    vm.filterPOPlaceholderText = 'Enter First Name';
    vm.filterDatePlaceholderText = 'Select a Date';

    vm.pipelineStages = [];
    vm.stageColumns = [];
    vm.operators = [];

    vm.datepickerOptions = {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        showWeeks: false,
        startingDay: 0,
    };

    vm.defaultStage = {
        name: '-- Select a Stage --',
        pipelineStageName: 'null',
        pipelineStageId: -1,
    };
    vm.defaultColumn = {
        key: '-- Select a Column --',
        mapping: 'none',
        apiColumnId: -1,
    };
    vm.defaultOperator = {
        id: -1,
        value: 'none',
        label: '-- Select a Filter Operator --',
    };

    /*= =======================================
    =            Private Functions            =
    ======================================== */
    function initializeFields() {
        vm.filterValue = '';
        vm.filterFirstName = '';
    }

    function getColumns() {
        vm.stageColumns = _.reject(
            PipelineFilterFactory.getStageColumns(vm.selectedStage.pipelineStageId),
            col => col.filter === undefined,
        );
        if (_.findWhere(vm.stageColumns, {
            mapping: 'none',
        }) === undefined) {
            vm.stageColumns.unshift(vm.defaultColumn);
        }
        vm.selectedColumn = vm.stageColumns[0];
    }

    function getOperators() {
        if (vm.selectedColumn.filter.type === 'predefined') {
            switch (vm.selectedColumn.filter.key) {
            case 'status':
            case 'finDocStatus':
            case 'fundingRequestStates':
            case 'closedStatus':
                vm.operators = _.filter(
                    PipelineFilterFactory.getFilterOptions()[vm.selectedColumn.filter.key],
                    status => status.pipelineStageId === vm.selectedStage.pipelineStageId,
                );
                break;
            case 'leadStatus':
                vm.operators = _.map(
                    PipelineFilterFactory.getFilterOptions()[vm.selectedColumn.filter.key],
                    leadStatus => ({
                        id: leadStatus.id,
                        value: leadStatus.value,
                        label: leadStatus.label,
                    }),
                );
                break;
            default:
                vm.operators = PipelineFilterFactory.getFilterOptions()[vm.selectedColumn.filter.key];
                break;
            }
        } else {
            vm.operators = PipelineMappings.getOperators(vm.selectedColumn.mapping);
        }
        vm.selectedOperator = vm.operators[0];
    }

    function deconstructFilterData(data) {
    // Find Stage dropdown value
        if (data.PipelineStageId !== undefined && data.PipelineStageId !== null) {
            const stg = _.find(vm.pipelineStages, stage => stage.pipelineStageId === data.PipelineStageId);
            if (stg !== undefined && stg !== null) {
                vm.selectedStage = stg;
            }
        } else {
            vm.selectedStage = _.find(vm.pipelineStages, stage => stage.pipelineStageId === 1);
        }
        getColumns();

        // Find Column dropdown value.
        if (data.filterOptions.FilterColumnId !== undefined && data.filterOptions.FilterColumnId !== null) {
            const col = _.find(vm.stageColumns, column => column.apiColumnId === data.filterOptions.FilterColumnId);
            if (col !== undefined && col !== null) {
                vm.selectedColumn = col;
            }
            getOperators();
        }

        // Find Operator dropdown value.
        let opr;
        if (vm.selectedColumn.filter.type === 'predefined') {
            opr = _.find(vm.operators, operator => operator.value === data.filterOptions.Value);
            if (opr !== undefined && opr !== null) {
                vm.selectedOperator = opr;
            }
        } else {
            if (data.filterOptions.FilterOperatorId !== undefined && data.filterOptions.FilterOperatorId !== null) {
                opr = _.find(vm.operators, operator => operator.value === data.filterOptions.FilterOperatorId);
                if (opr !== undefined && opr !== null) {
                    vm.selectedOperator = opr;
                }
            }

            // Populate field values.
            if (data.filterOptions.Value !== undefined && data.filterOptions.Value !== null && data.filterOptions.Value !== '') {
                vm.filterValue = data.filterOptions.Value;
                if (vm.selectedColumn.filter.type === 'propertyOwner') {
                    vm.filterTermPlaceholderText = 'Enter Last Name';
                } else {
                    vm.filterTermPlaceholderText = 'Enter Term';
                }
            }
            if (data.filterOptions.Value2 !== undefined && data.filterOptions.Value2 !== null && data.filterOptions.Value2 !== '') {
                vm.filterFirstName = data.filterOptions.Value2;
            }
        }
    }

    function getStages() {
        vm.pipelineStages = _.map(PipelineFactory.getPipelineStages(), _.clone);
        if (_.findWhere(vm.pipelineStages, {
            pipelineStageId: -1,
        }) === undefined) {
            vm.pipelineStages.unshift(vm.defaultStage);
        }
        const options = PipelineFactory.getPipelineDataOptions();
        if (options.filterOptions !== undefined && options.filterOptions !== null) {
            deconstructFilterData(options);
        } else {
            vm.selectedStage = vm.pipelineStages[0];
            initializeFields();
        }
    }

    function loadFilterData() {
        PipelineFilterFactory.getFilterOptions();
    }

    function getSalesReps() {
        UserData.getCurrentLocation().then((currentLocation) => {
            if (currentLocation.ContractorId === '') {
                UserData.getUserLocations().then((response) => {
                    const contractorIds = _.reject(_.pluck(response, 'ContractorId'), val => val === '');
                    PipelineFilterFactory.getSalesReps(contractorIds);
                });
            } else {
                PipelineFilterFactory.getSalesReps(currentLocation.ContractorId);
            }
        });
    }

    function constructFilterData() {
        const requestData = {};

        requestData.FilterColumnId = vm.selectedColumn.apiColumnId === -1 ? '' : vm.selectedColumn.apiColumnId;

        if (vm.selectedColumn.filter && vm.selectedColumn.filter.type === 'predefined') {
            requestData.FilterOperatorId = 1;
            requestData.Value = vm.selectedOperator.value;
        } else {
            requestData.FilterOperatorId = vm.selectedOperator.id === -1 ? '' : vm.selectedOperator.value;
            requestData.Value = vm.filterValue === undefined ? '' : vm.filterValue;
            if (vm.filterFirstName !== undefined && vm.filterFirstName !== null && vm.filterFirstName !== '') {
                requestData.Value2 = vm.filterFirstName;
            }
        }

        return requestData;
    }

    function constructFilterDataset() {
        const path = [vm.selectedStage.name];
        if (vm.selectedColumn.apiColumnId !== -1) {
            path.push(vm.selectedColumn.key);
        }
        if (vm.selectedOperator.id !== undefined && vm.selectedOperator.id !== -1) {
            path.push(vm.selectedOperator.label);
        }
        if (vm.filterFirstName !== undefined && vm.filterFirstName !== '' && vm.filterValue !== undefined && vm.filterValue !== '') {
            path.push(`${vm.filterFirstName} ${vm.filterValue}`);
        } else if (vm.filterValue !== undefined && vm.filterValue !== '' && vm.selectedColumn.filter.type === 'date') {
            path.push($filter('date')(vm.filterValue, 'MM/dd/yyyy'));
        } else if (vm.filterValue !== undefined && vm.filterValue !== '' && vm.selectedColumn.filter.type === 'currency') {
            path.push($filter('currency')(vm.filterValue));
        } else if (vm.filterValue !== undefined && vm.filterValue !== '') {
            path.push(vm.filterValue);
        }
        return path;
    }

    function init() {
        getStages();
        getSalesReps();
        loadFilterData();
    }

    init();
    /* -----  End of Private Functions  ------ */

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.closePipelineFilterModal = function closePipelineFilterModal() {
        $scope.$close();
    };

    vm.stageClicked = function stageClicked(item) {
        vm.selectedStage = item;
        if (item.pipelineStageId === -1) {
            vm.stageColumns = [];
            vm.operators = [];
        } else {
            getColumns();
            vm.operators = [];
            initializeFields();
        }
    };

    vm.columnClicked = function columnClicked(item) {
        vm.selectedColumn = item;
        if (item.mapping !== 'none') {
            getOperators();
            initializeFields();
            if (vm.selectedColumn.mapping === 'propertyOwner') {
                vm.filterTermPlaceholderText = 'Enter Last Name';
            } else {
                vm.filterTermPlaceholderText = 'Enter Term';
            }
        } else {
            vm.operators = [];
            initializeFields();
        }
    };

    vm.operatorClicked = function operatorClicked(item) {
        vm.selectedOperator = item;
    };

    vm.submitFilter = function submitFilter(isValid) {
        if (isValid) {
            if (vm.selectedStage.pipelineStageId !== -1) {
                const filterData = constructFilterData();
                const dataOptions = {
                    PipelineStageId: vm.selectedStage.pipelineStageId,
                    filterOptions: filterData,
                };
                PipelineFactory.setPipelineDataOptions(dataOptions);
                PipelineFactory.clearPipelineDataOption('sortOptions');
                PipelineFactory.pipelineFilterItems = constructFilterDataset();
            } else {
                PipelineFactory.clearPipelineDataOption('filterOptions');
                PipelineFactory.pipelineFilterItems = [];
                vm.selectedStage = vm.lastStage;
                vm.lastStage = {};
            }
            vm.closePipelineFilterModal();
            $state.go('pipeline', {
                stageName: vm.selectedStage.pipelineStageName,
            }, {
                reload: true,
            });
        }
    };

    vm.clearClicked = function clearClicked() {
        vm.lastStage = _.clone(vm.selectedStage);
        vm.selectedStage = vm.pipelineStages[0];
        vm.stageColumns = [];
        vm.operators = [];
    };

    vm.open = function open() {
        if (vm.opened === true) {
            vm.opened = false;
        } else {
            vm.opened = true;
        }
    };

    /* -----  End of Public Functions  ------ */
}



// WEBPACK FOOTER //
// ./src/app/pipeline/filter/pipelineFilterModalController.js